module.exports = __webpack_public_path__ + "static/img/bg6.ac61c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg6.jpg
// module id = zWgx
// module chunks = 1